<template>
    <div class="InstagramBusinessContentMediaFeed well p-0 mb-0">
        <InstagramBusinessContentFeed :contents="contents" class="p-5">
            <template v-slot:heading="">
                Feed aktivitet
            </template>
        </InstagramBusinessContentFeed>

        <MetricsBar
            v-if="mediaWithStats.count() > 0"
            :metrics="metrics"
            class="py-5 px-5 sm:px-12 my-5"
        />

        <div class="p-5">
            <h3 class="font-medium not-italic">
                Mest likede billeder
            </h3>

            <ContentsGrid :contents="topMedia" :rows="{ default: 2, md: 1 }">
                <template v-slot:default="{ contents }">
                    <a
                        v-for="content of contents"
                        :key="content.id"
                        :href="content.media_url"
                        class="anonymous"
                        target="_blank"
                        title="Vis opslag"
                    >
                        <InstagramBusinessContentCard :content="content" :show-stats="false" />
                    </a>
                </template>
            </ContentsGrid>
        </div>
    </div>
</template>

<style type="text/less" lang="less"></style>

<script>
import ContentsGrid from 'dashboard-js/components/contents/ContentsGrid'
import InstagramBusinessContentCard from 'dashboard-js/components/influencers/InstagramBusinessContentCard'
import InstagramBusinessContentFeed from 'dashboard-js/components/influencers/InstagramBusinessContentFeed'
import MetricsBar from 'dashboard-js/components/MetricsBar'
import collect from 'collect.js'

export default {
    components: {
        ContentsGrid,
        InstagramBusinessContentCard,
        MetricsBar,
        InstagramBusinessContentFeed,
    },

    props: ['channel', 'contents'],

    computed: {
        metrics() {
            return [
                {
                    label: 'Gns. eksponeringer',
                    value: this.avgViews,
                    tooltip:
                        'Gennemsnitlig antal eksponeringer for perioden er beregnet på antal opslag divideret med samlet antal eksponeringer.',
                },
                {
                    label: 'Gns. rækkevidde',
                    value: this.avgUniqueViews,
                    tooltip:
                        'Gennemsnitlig rækkevidde for perioden er beregnet på antal opslag divideret med den totale rækkevidde.',
                },
                {
                    label: 'Gns. engagement',
                    value: this.avgEngagement,
                    tooltip:
                        'Gennemsnitlig engagement for perioden er beregnet på antal opslag divideret med samlet antal likes og kommentarer.',
                },
                {
                    label: 'Engagement rate',
                    value: this.engagementRate,
                    tooltip:
                        'Engagement rate for perioden er beregnet på den totale engagement divideret i antal følgere.',
                },
            ]
        },

        avgViews() {
            return Math.round(this.mediaWithStats.map(item => item.latest_stat.views_total).avg())
        },

        avgUniqueViews() {
            return Math.round(this.mediaWithStats.map(item => item.latest_stat.views_unique).avg())
        },

        avgEngagement() {
            return Math.round(
                this.mediaWithStats
                    .map(item => item.latest_stat.payload.engagement)
                    .pipe(engagements =>
                        engagements.count() < 1 ? engagements.push(0) : engagements
                    )
                    .avg()
            )
        },

        engagementRate() {
            return Math.round((this.avgEngagement / this.channel.reach) * 100).toString() + '%'
        },

        mediaWithStats() {
            return collect(this.contents).filter(
                content => content.latest_stat.views_total !== null
            )
        },

        topMedia() {
            return collect(this.contents)
                .sortByDesc(content => content['latest_stat']['likes'])
                .all()
        },
    },
}
</script>
